var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"charts"},[_c('vue-highcharts',{ref:"drilldownChart",attrs:{"highcharts":_vm.Highcharts,"options":_vm.barOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }